//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { LocationAddressUpdateItem } from './LocationAddressUpdateItem';
import { LocationAddressType } from './Enums';

export class StudentsHomeAddressUpdateItem extends LocationAddressUpdateItem {
    override readonly AddressType: LocationAddressType = LocationAddressType.StudentsHome;

    constructor(initializer?: Partial<Omit<StudentsHomeAddressUpdateItem, "AddressType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "StudentsHomeAddressUpdateItem";
}
